import _uniqWith from 'lodash/uniqWith'
import { FIELDS } from './constants'

const compareFn = (item1, item2) => item1.name === item2.name || item1.value === item2.value

export const validateForm = (valuesData, customFieldsData) => {
  const errors = {}

  for (const name in FIELDS) {
    const { key, optionsKey } = FIELDS[name]

    if (valuesData.type === key && !valuesData[optionsKey].length) {
      errors[optionsKey] = 'You must add at least one option.'
    }

    if (
      valuesData.defaultValue &&
      valuesData.type === key &&
      !valuesData[optionsKey]?.find(option => option.value === valuesData.defaultValue)
    ) {
      errors.defaultValue = 'Invalid default value'
    }

    const uniqueSelectOptions = _uniqWith(valuesData.selectOptions, compareFn)
    if (uniqueSelectOptions.length !== valuesData.selectOptions.length) {
      errors.selectOptions = 'Options with same name or value are not allowed.'
    }
    const uniqueSelectMultiOptions = _uniqWith(valuesData.multiSelectOptions, compareFn)
    if (uniqueSelectMultiOptions.length !== valuesData.multiSelectOptions.length) {
      errors.multiSelectOptions = 'Options with same name or value are not allowed.'
    }
    const uniqueRadioOptions = _uniqWith(valuesData.radioOptions, compareFn)
    if (uniqueRadioOptions.length !== valuesData.radioOptions.length) {
      errors.radioOptions = 'Options with same name or value are not allowed.'
    }
  }

  if (/[0-9]/.test(valuesData.name) || /\s/g.test(valuesData.name)) {
    errors.name = 'Invalid'
  }

  const fieldsData = customFieldsData.filter(item => item.type === valuesData.parentType)[0]?.fields
  if (fieldsData && fieldsData.find(item => item.name === valuesData.name && item.id !== valuesData.id)) {
    errors.name = `The field name should be unique.`
  }

  return errors
}
